module.exports = __webpack_public_path__ + "assets/images/project/menu/netherlands-thumb.jpg?v=06645d37";